import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { commaJoined, looseString } from '../common/util/SearchParams'
import { CustomerDashboards } from '../components/customer-dashboards/CustomerDashboards'
import { CustomerDashboardTab } from '../components/customer-dashboards/CustomerDashboards.lib'

// Every tab renders under this one route, so `sortBy` is the union of all tabs' criteria and each
// dashboard narrows it to the values it supports.
const searchSchema = z.object({
  tab: z.enum(CustomerDashboardTab).optional(),
  sortBy: z
    .enum([
      'companyName',
      'customerAge',
      'dropoffPrevious',
      'dropoffCurrent',
      'numberAbandoned',
      'usageAsc',
      'usageDesc',
      'formsCompleted',
    ])
    .optional(),
  chartMetric: z.enum(['payAppCount', 'amountBilled']).optional(),
  accountOwner: looseString.optional(),
  companies: commaJoined.optional(),
})

export const Route = createFileRoute('/_a/customerDashboards')({
  component: CustomerDashboards,
  validateSearch: searchSchema,
})
